import hoverintent from 'hoverintent';
import lottie from '../libs/bodymoving';

const $ = jQuery;
class AnimatedIcon {
  static loaded = false;

  constructor(el) {
    this.el = el;
    this.target = this.el.getAttribute('data-js-animated-icon');
    this.hasAutoplay = this.el.hasAttribute('data-js-animated-icon-autoplay');
    this.animation = undefined;
    this.loop = this.el.hasAttribute('data-js-animated-icon-loop');
    this.root =
      typeof guidedogsGlobals !== 'undefined' ? guidedogsGlobals.iconPath : '/';
    this.onHover = this.el.hasAttribute('data-js-animated-icon-hover');
    this.addDeplayBetweenLoops = this.el.hasAttribute(
      'data-js-animated-icon-delay-loop',
    );
    this.deplayTime = this.addDeplayBetweenLoops
      ? this.el.getAttribute('data-js-animated-icon-delay-loop')
      : '';

    this.listenForEvents();
    this.setup();
  }

  setup() {
    const params = {
      container: this.el,
      renderer: 'svg',
      loop: this.loop,
      autoplay: this.hasAutoplay,
      path: `${this.root}icons/${this.target}.json`,
    };

    this.animation = lottie.loadAnimation(params);

    if (params.container.closest('.animated-icon-parent')) {
      params.container
        .closest('.animated-icon-parent')
        .addEventListener('mouseenter', this.handleEnter.bind(this));
      params.container
        .closest('.animated-icon-parent')
        .addEventListener('mouseleave', this.handleLeave.bind(this));
    }

    if (this.addDeplayBetweenLoops && this.deplayTime) {
      this.animation.addEventListener(
        'complete',
        this.playLoopWithDeplay.bind(this),
      );
    }

    if (
      params.container.closest('[data-js-animated-icon-parent="play-once"]')
    ) {
      const link = params.container.closest(
        '[data-js-animated-icon-parent="play-once"]',
      );
      const animatedIcon = this;

      const opts = {
        interval: 200,
      };

      hoverintent(
        link,
        () => {
          // Handler in
          animatedIcon.animation.playSegments([0, 50], true);
        },
        () => {
          // Handler out
          animatedIcon.animation.playSegments([91, 138]);
        },
      ).options(opts);
    }
  }

  playLoopWithDeplay() {
    setTimeout(() => {
      this.animation.goToAndPlay(0);
    }, this.deplayTime);
  }

  resetAnimation() {
    if (this.animation.currentRawFrame === 0) {
      setTimeout(this.resetAnimation.bind(this), 10);
    } else {
      this.animation.stop();
      this.animation.setCurrentRawFrameValue(1);
    }
  }

  handleEnter() {
    lottie.setDirection(1);
    this.animation.play();
  }

  handleLeave() {
    lottie.setDirection(-1);
    this.animation.play();
    this.animation.addEventListener('loopComplete', () =>
      this.animation.stop(),
    );
  }

  playFromStart() {
    this.animation.goToAndPlay(0);
  }

  listenForEvents() {
    $(this.el).on('lottie.play', () => {
      this.animation.play();
    });
    $(this.el).on('lottie.replay', () => {
      this.playFromStart();
    });
    $(this.el).on('lottie.stop', () => {
      this.animation.stop();
    });
  }

  static globalEventsListener() {
    $(window).on('lottie.animate', (e, el) => {
      new AnimatedIcon(el);
    });

    document.addEventListener('animatedIcons.reinit', () => {
      init();
    });
  }
}

export function init() {
  const icons = document.querySelectorAll('[data-js-animated-icon]');

  if (icons.length > 0) {
    icons.forEach((icon) => {
      new AnimatedIcon(icon);
    });
  }

  if (!AnimatedIcon.loaded) {
    AnimatedIcon.loaded = true;
    AnimatedIcon.globalEventsListener();
  }
}
